/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { fragment } from 'ember-data-model-fragments/attributes';
import type GradescheduleNumeric from '@linc-technologies/linced-common/models/assessments/gradeschedule-numeric';
import type GradescheduleSelect from '@linc-technologies/linced-common/models/assessments/gradeschedule-select';
import type Person from '@linc-technologies/linced-common/models/person';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: assessments.GradeSchedule.
export default class GradeSchedule extends Model {
  declare [Type]: 'assessments/grade-schedule';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string; // TODO: implement when we have Campuses

  @belongsTo('person', { async: true, inverse: null })
  declare authorId: AsyncBelongsTo<Person>;

  @alias('authorId')
  declare author: AsyncBelongsTo<Person>;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('boolean', { defaultValue: false })
  declare isLocked: boolean;

  @attr('boolean', { defaultValue: false })
  declare isHidden: boolean;

  @attr('string', { defaultValue: '' })
  declare templateId: string; // TODO: implement once Templates are added

  @attr('boolean', { defaultValue: false })
  declare isCustom: boolean;

  @attr('boolean', { defaultValue: false })
  declare isShared: boolean;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('string', { defaultValue: '' })
  declare key: string;

  @attr('number', { defaultValue: 0 })
  declare awardMethod: number;

  @fragment('assessments/gradeschedule-select')
  declare select: GradescheduleSelect | null;

  @fragment('assessments/gradeschedule-numeric')
  declare numeric: GradescheduleNumeric | null;
}
